import { render } from "./DashboardCardExpand.vue?vue&type=template&id=32651440"
import script from "./DashboardCardExpand.vue?vue&type=script&lang=js"
export * from "./DashboardCardExpand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__